import * as Sentry from '@sentry/react';

import { ErrorFallback } from './error-fallback';

import type { ReactNode } from 'react';

/**
 * Outermost safety net: anything escaping every route and widget boundary lands here as a full-page
 * fallback with a hard reload. `Sentry.ErrorBoundary` both renders the fallback and reports the
 * exception, so a manual `reportError` call here would double-report.
 */
export function RootErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <ErrorFallback error={error} variant="root" onRetry={() => window.location.reload()} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
